/* eslint-disable class-methods-use-this */
import { Component, HostListener, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { MediaContent } from "src/app/types/types.service";

@Component({
    selector: "app-video-fullscreen",
    templateUrl: "./video-fullscreen.component.html",
    styleUrls: ["./video-fullscreen.component.scss"],
})
export class VideoFullscreenComponent implements OnInit {
    @Input() video: MediaContent;

    videoElement: HTMLVideoElement;

    constructor(public activeModal: NgbActiveModal) {}

    ngOnInit(): void {
        this.videoElement = document.querySelector(
            "#my-video",
        ) as HTMLVideoElement;
        // this.toggleFullScreen();
    }

    onClose() {
        this.activeModal.close();
    }

    /**
     * Listener for fullsceen events, if exit fullscreen, close modal
     */
    @HostListener("document:fullscreenchange", ["$event"])
    @HostListener("document:webkitfullscreenchange", ["$event"])
    @HostListener("document:mozfullscreenchange", ["$event"])
    @HostListener("document:MSFullscreenChange", ["$event"])
    fullScreen() {
        const state = document.fullscreenElement;
        if (!state) {
            this.onClose();
        }
    }

    toggleFullScreen() {
        if (this.videoElement.requestFullscreen) {
            this.videoElement.requestFullscreen();
        }
    }
}
